/*  ========================================================================
    # Scripts - Contact Request
    ========================================================================  */

/**
 * Script that handles the contact request.
 */

const ContactRequest = {
  cfg: {
    formElement: document.querySelector('.c-form--contact'),
    formFields: {
      fieldPhone: document.getElementById('phoneNumberContact'),
      fieldUTMSource: document.getElementById('utm_source_contact'),
      fieldUTMMedium: document.getElementById('utm_medium_contact'),
      fieldUTMCampaign: document.getElementById('utm_campaign_contact'),
      fieldUTMTerm: document.getElementById('utm_term_contact'),
      fieldUTMContent: document.getElementById('utm_content_contact'),
      fieldPageUrl: document.getElementById('page_url_contact')
    },
    state: {
      error: 'c-form--error',
      success: 'c-form--success',
      pending: 'c-form--pending',
    }
  },

  /**
   * Fill hidden fields.
   */
  fillHiddenFields() {
    // Get all URL Parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Fill hidden fields
    this.cfg.formFields.fieldUTMSource.value = urlParams.get('utm_source');
    this.cfg.formFields.fieldUTMMedium.value = urlParams.get('utm_medium');
    this.cfg.formFields.fieldUTMCampaign.value = urlParams.get('utm_campaign');
    this.cfg.formFields.fieldUTMTerm.value = urlParams.get('utm_term');
    this.cfg.formFields.fieldUTMContent.value = urlParams.get('utm_content');
    this.cfg.formFields.fieldPageUrl.value = window.location.href;
  },

  /**
   * Handle form submission.
   */

  async formSubmit(captchaToken) {
    const formData = new FormData(this.cfg.formElement);
    const formAction = this.cfg.formElement.getAttribute('data-action');
    formData.append('recaptchaToken', captchaToken);
    formData.append('formAction', formAction);
    this.cfg.formElement.classList.add(this.cfg.state.pending);

    try {
      const response = await fetch('/wp-json/vandy/v1/form/send/contactRequest', {
        method: 'POST',
        body: formData
      });

      if (response.ok && response.status === 200) {
        console.log('Form submitted successfully');
        this.cfg.formElement.classList.add(this.cfg.state.success);
        this.cfg.formElement.classList.remove(this.cfg.state.pending);
      } else {
        this.cfg.formElement.classList.remove(this.cfg.state.pending);
        this.cfg.formElement.classList.add(this.cfg.state.error);
        console.error('Form submission failed:', response.statusText);
      }
    } catch (error) {
      this.cfg.formElement.classList.remove(this.cfg.state.pending);
      console.error(error);
    }
  },

  /**
   * Initialize.
   */
  init() {
    // Handle phone input
    if (this.cfg.formFields.fieldPhone) {
      this.cfg.formFields.fieldPhone.addEventListener('blur', () => {
        this.cfg.formFields.fieldPhone.value = this.cfg.formFields.fieldPhone.value.replace(
          /[^0-9\+]/g,
          ''
        );
      });
    }


    // Handle form submit
    if (this.cfg.formElement) {
      // Fill hidden fields
      this.fillHiddenFields();
      this.cfg.formElement.addEventListener('submit', e => {
        e.preventDefault();
        grecaptcha.ready(() => {
          grecaptcha
            .execute(window.jsLocalize.recaptchaSiteKey, { action: 'submit' })
            .then(token => {
              this.formSubmit(token);
            });
        });
      });
    }
  }
};

export default ContactRequest;
